import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DetalleSolicitudComponent } from './comun/components/detalle-solicitud/detalle-solicitud.component';
import { DobleAutenticacionComponent } from './comun/components/doble-autenticacion/doble-autenticacion.component';
import { LogOutComponent } from './comun/components/log-out/log-out.component';
import { ActivarUsuarioComponent } from './core/activar-usuario/activar-usuario.component';
import { InicioSesionComponentCore } from './core/inicio-sesion/inicio-sesion.component';
import { LandingAceptacionCreacionCreditoComponent } from './core/landing-aceptacion-creacion-credito/landing-aceptacion-creacion-credito.component';
import { LandingAceptacionUsuarioComponent } from './core/landing-aceptacion-usuario/landing-aceptacion-usuario.component';
import { LandingAceptacionAliadoComponent } from './core/landing-aceptacion-aliado/landing-aceptacion-aliado.component';
import { PreguntasFrecuentesComponent } from './core/preguntas-frecuentes/preguntas-frecuentes.component';
import { RecodardContrasenaComponent } from './core/recordar-contrasena/recordar-contrasena.component';
import { VerificacionCorreoComponent } from './core/verificacion-correo/verificacion-correo.component';
import { HomeComponent } from './page/home/home.component';
import { InformacionContactoComponent } from './shared/components/informacion-contacto/informacion-contacto.component';
import { LineasAtencionComponent } from './shared/components/lineas-atencion/lineas-atencion.component';
import { MantenimientoProgramadoComponent } from './page-mantenimiento/mantenimiento-programado/mantenimiento-programado.component';
import { MantenimientoErrorComponent } from './page-mantenimiento/mantenimiento-error/mantenimiento-error.component';
import { sessionHomeRedirectGuard } from './core/session-home-redirect.guard';
import { SessionHomeRedirectComponent } from './core/session-home-redirect.component';
// Blog deshabilitado en navegación (HU 8300). Componentes y GestorContenidoService se conservan.
// import { ArticulosComponent } from './blog/articulos/articulos.component';
// import { NoticiasComponent } from './blog/noticias/noticias.component';
// import { DetallePublicacionComponent } from './blog/detalle-publicacion/detalle-publicacion.component';
// import { BlogComponent } from './blog/blog.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'Informacion-de-contacto', component: InformacionContactoComponent },
  { path: 'Lineas-de-atencion', component: LineasAtencionComponent },
  { path: 'mantenimiento-programado', component: MantenimientoProgramadoComponent },
  { path: 'mantenimiento-error', component: MantenimientoErrorComponent },
  { path: 'login', component: InicioSesionComponentCore },
  { path: 'solicitud/:persona/:id', component: DetalleSolicitudComponent },
  { path: 'InicioSesión', component: InicioSesionComponentCore },
  { path: 'verificacion', component: VerificacionCorreoComponent },
  {
    path: 'doble-autenticacion',
    component: DobleAutenticacionComponent,
  },
  {
    path: 'log-out',
    component: LogOutComponent,
  },
  {
    path: 'LandingAceptacionUsuario',
    component: LandingAceptacionUsuarioComponent,
  },
  {
    path: 'LandingAceptacionAliado',
    component: LandingAceptacionAliadoComponent,
  },
  {
    path: 'preguntas-frecuentes',
    component: PreguntasFrecuentesComponent,
  },
  {
    path: 'LandingAceptacionCreacionCredito',
    component: LandingAceptacionCreacionCreditoComponent,
  },
  {
    path: 'establecer-password',
    component: RecodardContrasenaComponent,
  },
  {
    path: 'establecer-password/:token',
    component: RecodardContrasenaComponent,
  },
  {
    path: 'activar-usuario',
    component: ActivarUsuarioComponent,
  },
  {
    path: 'recordar',
    component: ActivarUsuarioComponent,
  },
  {
    path: 'desbloquear',
    component: ActivarUsuarioComponent,
  },
  {
    path: 'informacion-de-contacto',
    component: InformacionContactoComponent,
  },
  {
    path: 'lineas-de-atencion',
    component: LineasAtencionComponent,
  },
  // {
  //   path: 'blog',
  //   component: BlogComponent,
  // },
  // {
  //   path: 'articulos',
  //   component: ArticulosComponent,
  // },
  // {
  //   path: 'noticias',
  //   component: NoticiasComponent,
  // },
  // {
  //   path: 'detalle/:tipo/:titulo/:id',
  //   component: DetallePublicacionComponent,
  // },
  {
    path: 'microempresario',
    loadChildren: () =>
      import('../app/microempresario/microempresario.module').then(
        (m) => m.MicroempresarioModule
      ),
  },
  {
    path: 'intermediario',
    loadChildren: () =>
      import('../app/intermediario/intermediario.module').then(
        (i) => i.IntermediarioModule
      ),
  },
  {
    path: '**',
    canActivate: [sessionHomeRedirectGuard],
    component: SessionHomeRedirectComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
